var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 2025 272",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.90472,0,0,3.93694,-32.3286,-53.8239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.688,14.688L10.625,82.188L88.594,82.188L49.688,14.688ZM50.156,73.594C56.875,73.594 62.188,68.125 62.188,61.563C62.188,59.219 61.563,57.188 60.469,55.313C66.563,58.75 70.625,64.063 70.625,64.063C70.625,64.063 61.719,75.938 49.844,75.938C37.969,75.938 28.906,64.063 28.906,64.063C28.906,64.063 33.281,58.125 40.156,54.688C38.906,56.563 38.125,58.906 38.125,61.563C38.125,68.125 43.438,73.594 50.156,73.594ZM41.719,59.375C41.719,57.5 43.125,56.094 45,56.094C46.875,56.094 48.281,57.5 48.281,59.375C48.281,61.25 46.875,62.656 45,62.656C43.125,62.656 41.719,61.094 41.719,59.375ZM74.531,65.938L81.563,77.969L59.688,77.969C67.031,75 72.188,69.063 74.531,65.938ZM68.75,55.937C64.219,51.875 57.656,47.969 49.688,47.969C41.719,47.969 35.156,51.875 30.625,55.937L49.688,22.969L68.75,55.937ZM24.844,65.938C27.187,68.906 32.344,74.844 39.844,77.969L17.969,77.969L24.844,65.938Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(7.12782,0,0,3.1279,-124.83,-472.508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.476,190.077C90.476,180.364 87.649,172.138 81.517,172.138L74.993,172.138L74.993,235.27L77.255,235.27L77.255,208.808L81.299,208.808C86.736,208.808 90.476,201.276 90.476,190.077ZM77.255,176.697L81.125,176.697C85.648,176.697 88.084,181.553 88.084,190.077C88.084,199.195 85.431,204.348 81.169,204.348L77.255,204.348L77.255,176.697Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "white",
      strokeWidth: "0.18px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.659,172.138L119.485,172.138L119.485,213.268C119.485,226.449 116.223,230.81 111.439,230.81C106.655,230.81 103.35,226.449 103.35,213.268L103.35,172.138L101.131,172.138L101.131,214.854C101.131,227.936 104.828,235.964 111.395,235.964C117.789,235.964 121.659,227.936 121.659,214.854L121.659,172.138Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "white",
      strokeWidth: "0.18px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.061,235.27L156.061,172.138L153.93,172.138L153.93,227.242L152.017,220.205L137.534,172.138L134.707,172.138L134.707,235.27L136.838,235.27L136.838,177.589L138.752,184.527L153.974,235.27L156.061,235.27Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "white",
      strokeWidth: "0.18px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.332,235.27L175.502,203.06L188.506,172.138L185.722,172.138L173.675,201.078L171.631,201.078L171.631,172.138L169.37,172.138L169.37,235.27L171.631,235.27L171.631,205.637L173.675,205.637L185.375,235.27L188.332,235.27Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "white",
      strokeWidth: "0.18px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.949,172.138L214.514,172.138L207.86,198.897L206.468,204.844L205.12,198.897L198.77,172.138L196.204,172.138L205.294,209.601L205.294,235.27L207.512,235.27L207.512,209.601L216.949,172.138Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "white",
      strokeWidth: "0.18px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.479,190.869C243.479,180.067 240.435,172.138 233.911,172.138L226.692,172.138L226.692,235.27L229.997,235.27L229.997,210.394L233.781,210.394C239.739,210.394 243.479,202.069 243.479,190.869ZM229.997,178.679L233.433,178.679C237.782,178.679 239.956,182.941 239.956,190.969C239.956,199.294 237.564,203.853 233.694,203.853L229.997,203.853L229.997,178.679Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "white",
      strokeWidth: "0.18px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.832,185.815L261.615,179.968L262.355,185.815L266.095,208.213L256.962,208.213L260.832,185.815ZM270.618,235.27L274.184,235.27L263.442,172.138L259.963,172.138L248.916,235.27L252.308,235.27L255.831,214.854L267.182,214.854L270.618,235.27Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "white",
      strokeWidth: "0.18px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.41,172.138L296.8,172.138L290.276,198.203L289.319,202.663L288.362,198.203L282.187,172.138L278.403,172.138L287.536,209.601L287.536,235.27L290.842,235.27L290.842,209.601L300.41,172.138Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "white",
      strokeWidth: "0.18px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-0.373589,-0.567642)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 127.159,
    y: 156.678,
    width: 41.065,
    height: 47.391,
    style: {
      fill: "white"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppLogo);
export default __webpack_public_path__ + "static/media/app-logo.ea798a75dfa1b0199e6fce5d797b8ea4.svg";
export { ForwardRef as ReactComponent };